import { useCarouselModuleModel } from '@/containers/homepage-v2/carousel-module/index.Model';
import { useEffect } from 'react';
import { useTranslation } from '@jupiter/plugin-runtime/i18n';

export const useCarouselModule = () => {
  const { i18n } = useTranslation();
  const { moduleArr, fetchModuleData } = useCarouselModuleModel();
  const gridCols = moduleArr?.[0]?.length === 1 ? 1 : 2;
  const showModule = moduleArr?.length > 0;

  useEffect(() => {
    fetchModuleData();
  }, [i18n.language]);
  return {
    gridCols,
    showModule,
    moduleArr,
  };
};
